import DOMPurify from "dompurify";

export const sanitizeContent = (content) => {
  if (!content) return "";
  return DOMPurify.sanitize(content, {
    ALLOWED_ATTR: [
      "target",
      "href",
      "style",
      "src",
      "width",
      "color",
      "background-color",
      "height",
      "alt",
      "title",
      "class",
      "id",
      "data-*",
      "onclick",
      "onmouseover",
      "onmouseout",
      "role",
      "tabindex",
      "for",
      "placeholder",
      "value"
    ]
  });
};
